"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5223],{

/***/ 55223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Google_CookieBanner; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./ui/elements/Link.tsx
var Link = __webpack_require__(68302);
// EXTERNAL MODULE: ./ui/components/CloseButton.tsx
var CloseButton = __webpack_require__(6485);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./hooks/useCookieSettings.tsx + 1 modules
var useCookieSettings = __webpack_require__(34457);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/twind/style/style.js
var style = __webpack_require__(79200);
;// CONCATENATED MODULE: ./hooks/useSharedRef.ts

var useSharedRef = function(a, b) {
    var ref = (0,react.useMemo)(function() {
        if (a === null && b === null) {
            return null;
        }
        return function(refValue) {
            if (typeof a === "function") {
                a(refValue);
            } else if (a) {
                a.current = refValue;
            }
            if (typeof b === "function") {
                b(refValue);
            } else if (b) {
                b.current = refValue;
            }
        };
    }, [
        a,
        b
    ]);
    return ref;
};

;// CONCATENATED MODULE: ./ui/elements/ToggleSwitch.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          & > input:checked + [data-type='check-btn'] {\n            @apply bg-puma-gold bg-opacity-40;\n            & > span {\n              @apply bg-puma-gold translate-x-full opacity-100 duration-200;\n            }\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Toggle = function(props, forwardedRef) {
    var id = props.id, disabled = props.disabled, className = props.className, rest = (0,_object_without_properties/* default */.Z)(props, [
        "id",
        "disabled",
        "className"
    ]);
    var inputRef = (0,react.useRef)(null);
    var ref = useSharedRef(forwardedRef, inputRef);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
        "data-disabled": disabled,
        htmlFor: id,
        className: (0,style.tw)([
            "relative flex items-center min-h-6 cursor-pointer",
            (0,style/* css */.iv)(_templateObject()),
            className, 
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                id: id,
                type: "checkbox",
                ref: ref,
                disabled: disabled,
                className: "hidden"
            }, rest)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "aria-hidden": true,
                "data-type": "check-btn",
                className: "h-2.5 w-10 rounded-full bg-opacity-30 bg-gray-300",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "absolute top-1/2 -translate-y-1/2 w-5 h-5 rounded-2xl bg-puma-gold cursor-pointer bg-gray-400 opacity-70 duration-150"
                })
            })
        ]
    });
};
var ToggleSwitch = /*#__PURE__*/ react.forwardRef(Toggle);

// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
;// CONCATENATED MODULE: ./ui/components/CookieConsentLayer/Google/CookieBanner.tsx











var CookieBanner = function() {
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref = (0,useCookieSettings/* useCookieSettings */.eK)(), form = ref.form, showCookieBanner = ref.showCookieBanner, showCookieSettings = ref.showCookieSettings, setShowCookieSettings = ref.setShowCookieSettings, acceptCookies = ref.acceptCookies;
    var ref1 = (0,react.useState)(useCookieSettings/* cookieOptions.0 */.Ci[0]), cookieState = ref1[0], setCookieState = ref1[1];
    var country = (0,useSiteConfig/* useSiteConfig */.N)().country;
    if (!showCookieBanner && !showCookieSettings) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "fixed bottom-0 w-full flex items-center justify-center ".concat([
            constants/* SUPPORTED_COUNTRY.US */.bM.US,
            constants/* SUPPORTED_COUNTRY.CA */.bM.CA
        ].includes(country) ? "z-[1500]" // Sets cookie banner above Stylitics modal (z-1000) to meet requirement of highest priority UI element
         : "z-30", " "),
        role: "dialog",
        "aria-modal": "false",
        "data-test-id": "cookie-banner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                className: "".concat(country === constants/* SUPPORTED_COUNTRY.US */.bM.US || constants/* SUPPORTED_COUNTRY.CA */.bM.CA ? "hidden" : "absolute top-0 right-0", " "),
                onClick: function() {
                    return acceptCookies();
                },
                invert: true,
                size: "sm"
            }),
            showCookieSettings ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full h-[100dvh] flex flex-col justify-end bg-puma-black bg-opacity-50",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-white w-full h-full border overflow-y-scroll overflow-hidden lg:h-60 xl:h-52 pb-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "desktop:flex desktop:items-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mobile:flex mobile:justify-end mobile:pr-5 tablet:flex tablet:justify-end tablet:pr-5 hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                                            className: "pt-6 px-7 ".concat(country === constants/* SUPPORTED_COUNTRY.US */.bM.US || constants/* SUPPORTED_COUNTRY.CA */.bM.CA ? "desktop:hidden flex justify-self-end" : "hidden", " "),
                                            onClick: function() {
                                                return setShowCookieSettings(false);
                                            },
                                            size: "base"
                                        })
                                    }),
                                    useCookieSettings/* cookieOptions.map */.Ci.map(function(cookie) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (0,twind.tw)("pt-6 px-7 mx-auto animate-fade-in max-w-screen-3xl lg:pr-24 lg:pl-6 3xl:pl-0", cookieState.label !== cookie.label && "lg:hidden"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "font-bold text-xl uppercase border-l-4 border-[#A3885f] pl-1 lg:border-none",
                                                            children: t(cookie.title)
                                                        }),
                                                        cookie.toggle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleSwitch, {
                                                            ref: form.register(),
                                                            name: cookie.label,
                                                            id: cookie.title
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "uppercase text-puma-gold",
                                                            children: t("alwaysActive")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "py-4",
                                                    children: t(cookie.label)
                                                })
                                            ]
                                        }, cookie.label);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                                        className: "pt-5 pr-7 ".concat(country === constants/* SUPPORTED_COUNTRY.US */.bM.US || constants/* SUPPORTED_COUNTRY.CA */.bM.CA ? "mobile:hidden tablet:hidden" : "hidden", " "),
                                        onClick: function() {
                                            return setShowCookieSettings(false);
                                        },
                                        size: "base"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-8 p-8 lg:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                    label: t("confirmMyChoice"),
                                    onClick: acceptCookies,
                                    variant: "primary",
                                    className: "w-full"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-puma-black-100 p-8 w-full flex hidden lg:flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex max-w-screen-3xl w-full m-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-1 items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "flex text-white",
                                        role: "menubar",
                                        children: useCookieSettings/* cookieOptions.map */.Ci.map(function(selection) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                className: "cursor-pointer pr-10 xl:pr-12",
                                                onClick: function() {
                                                    return setCookieState(selection);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (0,twind.tw)("text-base block mt-1 pb-1 whitespace-nowrap nav-underline font-bold 3xl:text-lg uppercase hover:nav-underline-selected", (cookieState === null || cookieState === void 0 ? void 0 : cookieState.label) === selection.label && "nav-underline-selected"),
                                                    children: t(selection.title)
                                                })
                                            }, selection.label);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex lg:justify-end",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex justify-end w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                                label: t("confirmMyChoice"),
                                                onClick: acceptCookies,
                                                variant: "primary",
                                                className: "whitespace-nowrap px-4 w-full px-2 hover:bg-[#A3885F] xl:px-8 xl:mx-4"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                                label: t("acceptAll"),
                                                onClick: function() {
                                                    form.setValue("userExperience", true);
                                                    form.setValue("marketing", true);
                                                    acceptCookies();
                                                },
                                                variant: "primary",
                                                className: "whitespace-nowrap w-full xs:w-auto px-8 hidden hover:bg-[#A3885F] xl:flex text-sm xl:text-base"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }) : country === constants/* SUPPORTED_COUNTRY.US */.bM.US || constants/* SUPPORTED_COUNTRY.CA */.bM.CA ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-puma-black-100 py-5 mobile:px-4 px-8 w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-white",
                            "data-test-id": "cookie-banner-message",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    href: "/help/privacy-policy",
                                    rel: "noreferrer",
                                    className: "text-white text-sm font-bold hover:text-[#DFE0E1]",
                                    children: t("cookieNoticeCTAText")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        " ",
                                        t("or"),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "text-white cursor-pointer font-bold text-sm hover:text-[#DFE0E1]",
                                    onClick: function() {
                                        return setShowCookieSettings(true);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "mobile:inline tablet:inline desktop:hidden",
                                            children: t("tapHere")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "mobile:hidden tablet:hidden desktop:inline",
                                            children: t("clickHere")
                                        })
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("optOutCookies")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between align-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ButtonCta */.NlM, {
                                    invert: true,
                                    label: t("manageCookies"),
                                    mode: "text",
                                    size: "base",
                                    variant: "primary",
                                    className: "mobile:hidden tablet:hidden desktop:inline",
                                    onClick: function() {
                                        return setShowCookieSettings(true);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ButtonCta */.NlM, {
                                    className: "ml-3 mobile:hidden tablet:hidden desktop:inline",
                                    invert: true,
                                    label: t("allow"),
                                    mode: "text",
                                    size: "base",
                                    variant: "secondary",
                                    onClick: function() {
                                        form.setValue("userExperience", true);
                                        form.setValue("marketing", true);
                                        acceptCookies();
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                                    className: "mobile:ml-4 tablet:ml-6 ml-14",
                                    dataTestId: "cookie-banner-close-btn",
                                    onClick: function() {
                                        return acceptCookies();
                                    },
                                    invert: true,
                                    size: "sm"
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-puma-black-100 py-6 px-4 md:px-24 w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex w-full flex-col space-y-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-white text-lg mb-2 font-bold leading-none uppercase",
                                children: t("cookieNoticeHeader")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-white",
                                "data-test-id": "cookie-banner-message",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "hidden md:inline",
                                        children: [
                                            t("cookieNoticeText"),
                                            "\xa0"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                        href: "/help/privacy-policy",
                                        rel: "noreferrer",
                                        className: "text-white underline text-sm font-bold hover:text-[#DFE0E1]",
                                        children: t("cookieNoticeCTAText")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "md:hidden",
                                        children: [
                                            " ",
                                            t("or"),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "hidden md:inline",
                                        children: " ".concat(t("orClick"), " ")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-white underline cursor-pointer font-bold text-sm hover:text-[#DFE0E1]",
                                        onClick: function() {
                                            return setShowCookieSettings(true);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "md:hidden",
                                                children: t("clickHere")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "hidden sm:inline",
                                                children: t("manageCookies")
                                            })
                                        ]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "hidden md:inline",
                                        children: t("optOutCookies")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "md:hidden",
                                        children: " ".concat(t("cookiesMobile"))
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Google_CookieBanner = (CookieBanner);


/***/ })

}]);